import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation,
} from '@angular/core';
import { FormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { StatusService } from '../status.service';
import { IStatus } from '../status.model';
import { of, Observable, Subject } from 'rxjs';
import { map } from 'rxjs/operators';
import { ScopeSelectDefault } from '../../../../shared/components/ms-select/ms-select.component';

@Component({
	selector: 'status-select',
	templateUrl: './status-select.component.html',
	styleUrls: [],
	encapsulation: ViewEncapsulation.None,
	standalone: false,
})
export class StatusSelectComponent implements OnInit, OnDestroy {
	@Input() formGroup: FormGroup;
	@Input() title: string = 'Status';
	@Input() key: string = 'status';
	@Output() statusChange = new EventEmitter<IStatus>();

	public fetch$: Observable<ScopeSelectDefault[]>;
	public options: { userCanEdit?: boolean; userCanNew?: boolean } = {};

	private _unsubscribeAll: Subject<any> = new Subject<any>();

	constructor(
		private statusService: StatusService,
		private _formBuilder: UntypedFormBuilder
	) {
		if (!this.formGroup) {
			this.formGroup = this._formBuilder.group({
				status: [null, [Validators.required]],
			});
		}
		this.fetch$ = this.statusService.query().pipe(
			map((statuses) =>
				(statuses || []).map((status) => ({
					id: status.id,
					name: status.name ?? String(status.id),
				}))
			)
		);
	}

	ngOnInit(): void {
		this._setValue();
	}

	ngOnDestroy(): void {
		this._unsubscribeAll.next(null);
		this._unsubscribeAll.complete();
	}

	valueChangeHandle(val: IStatus) {
		let _value = undefined;
		if (val !== undefined && val !== null) {
			_value = val;
			this.formGroup.get(this.key).setValue(_value);
		}
		this.statusChange.emit(_value);
	}

	private _setValue() {
		const value = this.formGroup.get(this.key).value;
		if (value !== '' && value !== null && value !== undefined && typeof value !== 'object') {
			this.formGroup.get(this.key).setValue({ id: value, name: value });
		}
	}
}
